:root {
  --semantic-colors-typography-heading: var(--primitives-colors-neutral-0);
  --semantic-colors-typography-body: var(--primitives-colors-neutral-100);
  --semantic-colors-typography-faded: var(--primitives-colors-neutral-300);
  --semantic-colors-typography-inverse: var(--primitives-colors-neutral-980);
  --semantic-colors-typography-inverse-disabled: var(--primitives-colors-other-bg-secondary-60);
  --semantic-colors-typography-link: var(--primitives-colors-brand-secondary);
  --semantic-colors-typography-link-disabled: var(--primitives-colors-other-brand-secondary-40);
  --semantic-colors-typography-link-hover: var(--primitives-colors-other-brand-secondary-400);
  --semantic-colors-typography-link-pressed: var(--primitives-colors-other-brand-secondary-600);
  --semantic-colors-typography-body-disabled: var(--primitives-colors-other-neutral-100-40);
  --semantic-colors-typography-heading-disabled: var(--primitives-colors-other-neutral-0-40);
  --semantic-colors-typography-error: var(--primitives-colors-functional-error);
  --semantic-colors-icons-default: var(--primitives-colors-neutral-100);
  --semantic-colors-icons-faded: var(--primitives-colors-neutral-300);
  --semantic-colors-icons-disabled: var(--primitives-colors-other-neutral-100-40);
  --semantic-colors-icons-opposite: var(--primitives-colors-neutral-980);
  --semantic-colors-icons-error: var(--primitives-colors-functional-error);
  --semantic-colors-icons-success: var(--primitives-colors-functional-success);
  --semantic-colors-icons-information: var(--primitives-colors-functional-information);
  --semantic-colors-icons-warning: var(--primitives-colors-functional-warning);
  --semantic-colors-bg-primary: var(--primitives-colors-neutral-990);
  --semantic-colors-bg-secondary: var(--primitives-colors-neutral-980);
  --semantic-colors-bg-tertiary: var(--primitives-colors-neutral-970);
  --semantic-colors-bg-inline-error: var(--primitives-colors-other-bg-red);
  --semantic-colors-bg-inline-success: var(--primitives-colors-other-bg-green);
  --semantic-colors-bg-inline-warning: var(--primitives-colors-other-bg-orange);
  --semantic-colors-bg-subtle: var(--primitives-colors-neutral-930);
  --semantic-colors-notification-success: var(--primitives-colors-functional-success);
  --semantic-colors-notification-error: var(--primitives-colors-functional-error);
  --semantic-colors-notification-information: var(--primitives-colors-functional-information);
  --semantic-colors-notification-warning: var(--primitives-colors-functional-warning);
  --semantic-colors-other-border: var(--primitives-colors-neutral-0);
  --semantic-colors-other-neutral-0-0: var(--primitives-colors-other-neutral-0-0);
  --semantic-colors-other-neutral-0-5: var(--primitives-colors-other-neutral-0-5);
  --semantic-colors-other-neutral-0-10: var(--primitives-colors-other-neutral-0-10);
  --semantic-colors-other-neutral-0-20: var(--primitives-colors-other-neutral-0-20);
  --semantic-colors-other-neutral-0-disabled: var(--primitives-colors-other-neutral-0-40);
  --semantic-colors-other-bg-tertiary-disabled: var(--primitives-colors-other-bg-tertiary-40);
  --semantic-colors-other-bg-tertiary-70: var(--primitives-colors-other-bg-tertiary-70);
  --semantic-colors-other-bg-tertiary-80: var(--primitives-colors-other-bg-tertiary-80);
  --semantic-colors-other-bg-secondary-disabled: var(--primitives-colors-other-bg-secondary-40);
  --semantic-colors-other-bg-primary-button: var(--primitives-colors-brand-secondary);
  --semantic-colors-other-brand-secondary-0: var(--primitives-colors-other-brand-secondary-0);
  --semantic-colors-other-brand-secondary-disabled: var(--primitives-colors-other-brand-secondary-40);
  --semantic-colors-other-link-states: var(--primitives-colors-other-brand-secondary-400);
  --semantic-colors-other-hover-bg: var(--primitives-colors-neutral-950);
  --semantic-colors-other-hover-subtle: var(--primitives-colors-neutral-910);
  --semantic-colors-other-subtle-disabled: rgba(48, 46, 46, 0.4);
  --semantic-colors-other-innershadow-0: var(--primitives-colors-other-bg-secondary-0);
  --semantic-colors-other-innershadow-25: var(--primitives-colors-other-bg-secondary-25);
  --semantic-colors-other-innershadow-60: var(--primitives-colors-other-bg-secondary-60);
  --semantic-colors-other-stepper: var(--primitives-colors-other-studio-2);
  --semantic-colors-other-logo: var(--primitives-colors-brand-primary);
  --semantic-colors-other-logo-black: var(--primitives-colors-neutral-990);
  --semantic-colors-other-logo-white: var(--primitives-colors-neutral-0);
}
